<template>
    <div class="buttoncart" :class="productType === 'variable' ? 'single_variation_wrap' : '' ">
        <p v-if="productType === 'variable' && actButton.stockStatus === 'instock'" :class="`stock ${isOutOfStock ? 'out-of-stock' : 'in-stock'}`">{{ isOutOfStock ? 'Out of stock' : 'In Stock' }}</p>
        <div class="woocommerce-variation-description">
            <p v-if="props.variable_description" v-html="htmlSpecialcharsDecode(props.variable_description)"></p>
        </div>
        <div class="buttoncart_top" :class="buttonCartClass">
            <template v-if="isRequestPrice">
                <NuxtLink class="single_add_to_cart_consultation" :to="`${baseUrl}consultation/?utm_page=${baseUrl}product/${slug}`">REQUEST CONSULTATION</NuxtLink>
            </template>
            <template v-else>
                <div class="sdj-single book-solite" v-if="hasShowEnquire">
                    <div class="sdj-enquiry">
                        <a class="enquiry-btn enquiry-btn-single yy" :href="linkEnquire === '/consultation' ? `${baseUrl}consultation/?utm_page=${baseUrl}product/${slug}` : linkEnquire">
                            ENQUIRE NOW
                        </a>
                    </div>
                </div>

                <button type="submit"
                    name="add-to-cart"
                    :class="[
                        'btn-single-atc',
                        'single_add_to_cart_button',
                        {
                            disabled: isDisabled,
                            check_bundle_add_cart: productType === 'yith_bundle'
                        }
                    ]"
                    :value="productType === 'simple' ? productData.ID : undefined"
                    :disabled="isDisabled"
                    v-if="hasShowAtc || (!hasShowAtc && !hasShowEnquire)"
                >
                    Add to cart
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"><circle cx="12" cy="2" r="0" fill="currentColor"><animate attributeName="r" begin="0" calcMode="spline" dur="1s" keySplines="0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8" repeatCount="indefinite" values="0;2;0;0"/></circle><circle cx="12" cy="2" r="0" fill="currentColor" transform="rotate(45 12 12)"><animate attributeName="r" begin="0.125s" calcMode="spline" dur="1s" keySplines="0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8" repeatCount="indefinite" values="0;2;0;0"/></circle><circle cx="12" cy="2" r="0" fill="currentColor" transform="rotate(90 12 12)"><animate attributeName="r" begin="0.25s" calcMode="spline" dur="1s" keySplines="0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8" repeatCount="indefinite" values="0;2;0;0"/></circle><circle cx="12" cy="2" r="0" fill="currentColor" transform="rotate(135 12 12)"><animate attributeName="r" begin="0.375s" calcMode="spline" dur="1s" keySplines="0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8" repeatCount="indefinite" values="0;2;0;0"/></circle><circle cx="12" cy="2" r="0" fill="currentColor" transform="rotate(180 12 12)"><animate attributeName="r" begin="0.5s" calcMode="spline" dur="1s" keySplines="0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8" repeatCount="indefinite" values="0;2;0;0"/></circle><circle cx="12" cy="2" r="0" fill="currentColor" transform="rotate(225 12 12)"><animate attributeName="r" begin="0.625s" calcMode="spline" dur="1s" keySplines="0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8" repeatCount="indefinite" values="0;2;0;0"/></circle><circle cx="12" cy="2" r="0" fill="currentColor" transform="rotate(270 12 12)"><animate attributeName="r" begin="0.75s" calcMode="spline" dur="1s" keySplines="0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8" repeatCount="indefinite" values="0;2;0;0"/></circle><circle cx="12" cy="2" r="0" fill="currentColor" transform="rotate(315 12 12)"><animate attributeName="r" begin="0.875s" calcMode="spline" dur="1s" keySplines="0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8" repeatCount="indefinite" values="0;2;0;0"/></circle></svg>
                </button>
            </template>
            <input type="hidden" name="gtm4wp_product_data" :value="JSON.stringify(props?.gtmItem)">
            <div
                class="tinv-wraper woocommerce tinv-wishlist tinvwl-after-add-to-cart tinvwl-woocommerce_after_add_to_cart_button"
                :data-tinvwl_product_id="productData.ID"
            >
            <!-- @click="wishListItem($event, productData.ID)" -->
            <!-- :class="{ active: isActive }" -->
                <a
                @click="handleClickWishlist($event, productData.ID)"
                :class="{ active: props.isActive }"
                role="button"
                tabindex="0"
                name=""
                aria-label=""
                class="tinvwl_add_to_wishlist_button tinvwl-icon-custom no-txt tinvwl-position-after"
                data-tinv-wl-list="[]"
                :data-tinv-wl-product="productData.ID"
                data-tinv-wl-productvariation="0"
                data-tinv-wl-productvariations="[]"
                :data-tinv-wl-producttype="productType"
                data-tinv-wl-action="addto"
                ></a>
                <div class="tinv-wishlist-clear"></div>
                <span class="kts-wishlist-tooltip">Add to wishlist and send to your friends</span>
            <div class="tinvwl-tooltip"></div>
        </div>
        </div>
        <p v-if="props.isPre0rder" class="usp_devilery">
            <span>Preorder - Ships by {{ shippingPreOderFinal }}</span>
            <img src="/single-product/cart_shipping_icon.png" alt="Preorder Shipping" />
        </p>
        <p v-else class="usp_devilery">
            <span>And shipped out by {{ shippingDataFinal }}</span>
            <img src="/single-product/cart_shipping_icon.png" alt="Shipping" />
        </p>
    </div>
</template>
<style lang="scss">
@import "@/assets/scss/components/product/_buttoncart.scss";
</style>
<script lang="ts" setup>
    import { calculateShippingDate, formatDate, formatDataDate } from '~/assist/ShippingDateCalculator';
    import { initAddToCart } from '~/assist/SingleProduct';
    import { useAddToCartState } from '~/composables/useAddToCartState';
    import type { IAPIResponseError } from '~/types/apiResponseError';

    const route = useRoute();
    const slug = route.params.slug as string;
    const runtimeConfig = useRuntimeConfig();
    const baseUrl = runtimeConfig.public.BASE_URL;
    const userStore = useUserStore();
    // const isActive = ref(false);
    const { $ajax } = useNuxtApp();
    const props = defineProps({
        data: Object,
        actButton: {
            type: Object,
            default: () => ({
                isRequestPrice: false,
                isEnquire: {},
                linkEnquire: "/consultation",
                stockStatus: ''
            })
        },
        isButtonActive: {
            type: Boolean,
            default: true
        },
        shippingDate:{
            type: Object,
        },
        isPre0rder: {
            type: Boolean,
            default: false
        },
        variable_description:{
            type: String,
            default: ''
        },
        isActive: {
            type: Boolean,
        },
        isStatusBundle: {
            type: Boolean,
        },
        product: {
            type: Object,
            default: null
        },
        productType: {
            type: String,
            default: ''
        },
        gtmItem: {
            type: Object,
        }
    });
    const emit = defineEmits(['handleWishlist']);
    const handleClickWishlist = (event: any, product_id: number) => {
        event.stopPropagation();
        event.preventDefault();
        emit('handleWishlist', product_id);
    }
    interface IResponse {
        success: boolean;
        data: any[];
    };
    interface ShippingData {
        shippingDay: string;
        publicHolidays: string[];
        preOrderType: string;
        preOrderDay: string;
        preOrderDate: string;
    }
    const shippingDataFinal = ref();
    const shippingPreOderFinal = ref();
    const shippingDate = computed(() => props.shippingDate);
    const productData = props.product;
    const { isOutOfStock, isDisabled } = useAddToCartState(props);

    watch(shippingDate, (newShippingDate) => {
        if (newShippingDate) {
            // Clone shipping data for manipulation
            const shippingDataClone = { ...newShippingDate } as ShippingData;
            const shippingDataFormat = calculateShippingDate(shippingDataClone);
            shippingDataFinal.value = formatDate(shippingDataFormat);

            // Handle pre-order type logic
            const shippingPreOderClone = { ...newShippingDate } as ShippingData;
            if (shippingPreOderClone.preOrderType === 'set_day') {
                shippingPreOderClone.shippingDay = shippingPreOderClone.preOrderDay;
                const shippingPreOderFormat = calculateShippingDate(shippingPreOderClone);
                shippingPreOderFinal.value = formatDate(shippingPreOderFormat);
            }
            if (shippingPreOderClone.preOrderType === 'set_date') {
                const preOrderDate = shippingPreOderClone.preOrderDate;
                const preOrderDateFormat = formatDataDate(Number(preOrderDate));
                shippingPreOderFinal.value = formatDate(preOrderDateFormat);
            }
        }
    }, { immediate: true }); // Trigger immediately on mount

    // Watch for changes in isPre0rder
    watch(
        () => props.isPre0rder, // Watch the isPre0rder prop
        (newIsPreOrder) => {
            if (newIsPreOrder) {
                const shippingPreOderClone = { ...shippingDate.value } as ShippingData;
                if (shippingPreOderClone.preOrderType === 'set_day') {
                    shippingPreOderClone.shippingDay = shippingPreOderClone.preOrderDay;
                    const shippingPreOderFormat = calculateShippingDate(shippingPreOderClone);
                    shippingPreOderFinal.value = formatDate(shippingPreOderFormat);
                }
                if (shippingPreOderClone.preOrderType === 'set_date') {
                    const preOrderDate = shippingPreOderClone.preOrderDate;
                    const preOrderDateFormat = formatDataDate(Number(preOrderDate));
                    shippingPreOderFinal.value = formatDate(preOrderDateFormat);
                }
            }
        }
    );

    const actButton = computed(() => props.actButton);
    const stockStatus = computed(() => {
        if (actButton.value) {
            return actButton.value.stockStatus;
        }
        return '';
    });
    const isRequestPrice = computed(() => {
        if (actButton.value) {
            return actButton.value.isRequestPrice;
        }
        return false;
    });
    const hasShowAtc = computed(() => actButton.value?.isEnquire ? Object.values(actButton.value.isEnquire).includes('show_atc') : false);
    const hasShowEnquire = computed(() => actButton.value?.isEnquire ? Object.values(actButton.value.isEnquire).includes('show_enquire') : false);
    const linkEnquire = computed( () => actButton.value?.linkEnquire ? actButton.value.linkEnquire : '/consultation');

    const buttonCartClass = computed(() => {
        if (actButton.value?.isRequestPrice) {
            return 'buttoncartconsultation_top';
        }
        if (!actButton.value?.isRequestPrice) {
            if (hasShowAtc.value && hasShowEnquire.value) {
                return 'two_buttoncart_top';
            } else if (hasShowEnquire.value) {
                return 'buttoncartenquire_top';
            }
        }
        return '';
    });

    const productType = ref(props.product.productType);



    onMounted(() => {
        initAddToCart();
    });
</script>
